import Button from '@mui/material/Button';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {LoadingButton} from '@mui/lab';

interface ModalProps extends DialogProps {
  open: boolean;
  title: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  hideConfirm?: boolean;
  handleCancel?: VoidFunction;
  handleConfirm?: VoidFunction;
  modalContent?: JSX.Element;
  confirmAction?: JSX.Element;
}

export default function Modal({
  open,
  title,
  modalContent,
  loading = false,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  hideConfirm = false,
  handleCancel = () => {},
  handleConfirm = () => {},
  confirmAction,
}: ModalProps) {
  const _handleCancel = () => {
    handleCancel();
  };
  const _handleConfirm = () => {
    handleConfirm();
  };
  return (
    <>
      <Dialog open={open} aria-labelledby="customized-dialog-title" fullWidth maxWidth="md">
        <DialogTitle sx={{m: 0, p: 2}} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent dividers sx={{minWidth: 600}}>
          {modalContent}
        </DialogContent>
        <DialogActions>
          <Button onClick={_handleCancel} disabled={loading}>
            {cancelText}
          </Button>
          {!hideConfirm &&
            (confirmAction ? (
              confirmAction
            ) : (
              <LoadingButton
                sx={{width: loading ? 110 : 'auto'}}
                variant="contained"
                loading={loading}
                loadingPosition="start"
                startIcon={<></>}
                onClick={_handleConfirm}
              >
                {confirmText}
              </LoadingButton>
            ))}
        </DialogActions>
      </Dialog>
    </>
  );
}
